// extracted by mini-css-extract-plugin
export default {"publication":"index_publication__54O10"};